<template>
  <div
    v-if="value"
    class="extras-mg-borde-izquierdo"
    :class="'background-color--' + value"
  ></div>
</template>

<script>
export default {
  name: 'BordeIzquierdoColor',
  props: {
    // Lo produce el value provider; puede venir vacio si la fila no matchea
    // ninguna regla, y entonces no se pinta nada.
    value: { type: String, required: false, default: '' },
  },
}
</script>

<style lang="scss">
/* La celda que nos contiene (.grid-view__row-info) es position: static en el
   core, asi que sin esto la barra se ancla a un ancestro lejano y termina
   debajo de la barra lateral. Se hace relativa solo cuando llevamos barra
   dentro, con :has(), para no cambiarle el layout a las vistas sin decorador. */
.grid-view__row-info:has(> .extras-mg-borde-izquierdo) {
  position: relative;
}

.extras-mg-borde-izquierdo {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 4px;
  pointer-events: none;
}
</style>
